
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","data-name":"Слой 1","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M117.05 69l3.34-4 2 1.61a2 2 0 001.27.45 2 2 0 001.27-3.54l-3.52-2.89-3.59-2.94a2 2 0 00-2.53 3.1l2 1.67L114 66.5a33.76 33.76 0 00-18-6.44V54h6a2 2 0 000-4H86a2 2 0 000 4h6v6.06a34.05 34.05 0 1025 9zM94 124a30 30 0 1130-30 30 30 0 01-30 30z"}}),_c('path',{attrs:{"d":"M103.9 72.22a2 2 0 10-1.66 3.64 19.94 19.94 0 11-20.73 2.64l-.28.93a2 2 0 001.32 2.5 2.06 2.06 0 00.59.09 2 2 0 001.91-1.42l1.84-6a2 2 0 00-1.32-2.5l-6-1.84a2 2 0 10-1.17 3.82l1.66.51a23.9 23.9 0 1023.85-2.37z"}}),_c('path',{attrs:{"d":"M92 99.41v.78a2 2 0 004 0v-.78a5.77 5.77 0 000-10.82V72.08a2 2 0 10-4 0v16.51a5.77 5.77 0 000 10.82zm2-7.18A1.77 1.77 0 1192.23 94 1.77 1.77 0 0194 92.23zM56 104H41V24h41v2a2 2 0 004 0v-4a2 2 0 00-2-2H39.62L11.14.35A2 2 0 008 2v60H2a2 2 0 00-2 2v11a2 2 0 004 0v-9h4v60a2 2 0 001.07 1.77 2 2 0 002.07-.12L39.62 108H56a2 2 0 000-4zM12 5.81l25 17.24V105l-25 17.19z"}}),_c('path',{attrs:{"d":"M101 22a5 5 0 010 10H66a2 2 0 000 4h35a9 9 0 000-18 2 2 0 000 4z"}}),_c('path',{attrs:{"d":"M118 26a2 2 0 000 4 6 6 0 010 12H55.14a2 2 0 000 4H118a10 10 0 000-20z"}})])
          )
        }
      }
    